import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "https://doctor-appointment-1-yf2j.onrender.com";

const CHAT_STYLES = `
  .cb-widget {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 9999;
    font-family: 'Outfit', sans-serif;
  }
  
  .cb-bubble {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #0284c7 0%, #7c3aed 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    cursor: pointer;
    box-shadow: 0 10px 25px rgba(2, 132, 199, 0.4);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .cb-bubble:hover {
    transform: scale(1.1) rotate(5deg);
    box-shadow: 0 15px 35px rgba(2, 132, 199, 0.6);
  }
  
  .cb-panel {
    position: fixed;
    bottom: 100px;
    right: 30px;
    width: 380px;
    height: 560px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(16px);
    border: 1px solid rgba(224, 242, 254, 0.7);
    border-radius: 24px;
    box-shadow: 0 20px 50px rgba(186, 230, 253, 0.5);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: cb-slide-up 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }
  
  @keyframes cb-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .cb-header {
    background: linear-gradient(135deg, #0284c7 0%, #7c3aed 100%);
    color: white;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  .cb-header-title {
    font-weight: 800;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    letter-spacing: -0.5px;
  }
  .cb-header-close {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    font-size: 20px;
    cursor: pointer;
    transition: color 0.2s;
  }
  .cb-header-close:hover {
    color: white;
  }
  
  .cb-messages {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: radial-gradient(circle at top right, rgba(240, 249, 255, 0.5) 0%, rgba(255, 255, 255, 0.8) 100%);
  }
  
  .cb-message {
    max-width: 85%;
    padding: 12px 16px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  }
  
  .cb-msg-bot {
    align-self: flex-start;
    background: white;
    color: #334155;
    border-bottom-left-radius: 4px;
    border: 1px solid #f1f5f9;
  }
  .cb-msg-user {
    align-self: flex-end;
    background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
    color: white;
    border-bottom-right-radius: 4px;
    box-shadow: 0 4px 12px rgba(2, 132, 199, 0.2);
  }
  
  .cb-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
    width: 100%;
  }
  .cb-option-btn {
    width: 100%;
    text-align: left;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #0284c7;
    cursor: pointer;
    transition: all 0.2s;
  }
  .cb-option-btn:hover {
    background: #f0f9ff;
    border-color: #bae6fd;
    transform: translateX(4px);
  }
  
  .cb-input-area {
    padding: 16px;
    background: white;
    border-top: 1px solid #f1f5f9;
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .cb-input {
    flex: 1;
    border: 1px solid #e2e8f0;
    padding: 12px 16px;
    border-radius: 14px;
    font-size: 14px;
    outline: none;
    font-family: inherit;
    font-weight: 500;
    transition: all 0.2s;
    background: #f8fafc;
  }
  .cb-input:focus {
    border-color: #38bdf8;
    background: white;
    box-shadow: 0 0 0 4px rgba(56, 189, 248, 0.1);
  }
  .cb-send {
    background: linear-gradient(135deg, #0284c7 0%, #7c3aed 100%);
    border: none;
    color: white;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(2, 132, 199, 0.2);
  }
  .cb-send:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(2, 132, 199, 0.3);
  }
  
  .cb-typing {
    display: flex;
    gap: 4px;
    padding: 12px 16px;
    background: white;
    border: 1px solid #f1f5f9;
    border-radius: 16px;
    border-bottom-left-radius: 4px;
    align-self: flex-start;
    width: fit-content;
  }
  .cb-dot {
    width: 8px;
    height: 8px;
    background: #cbd5e1;
    border-radius: 50%;
    animation: cb-dot-bounce 1.4s infinite ease-in-out both;
  }
  .cb-dot:nth-child(1) { animation-delay: -0.32s; }
  .cb-dot:nth-child(2) { animation-delay: -0.16s; }
  
  @keyframes cb-dot-bounce {
    0%, 80%, 100% { transform: scale(0); }
    40% { transform: scale(1); }
  }
  
  @media (max-width: 480px) {
    .cb-panel {
      width: calc(100vw - 30px);
      height: calc(100vh - 120px);
      bottom: 90px;
      right: 15px;
    }
  }

  .cb-new-chat-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  .cb-new-chat-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }

  .cb-calendar {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 12px;
    margin-top: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    max-width: 100%;
  }
  .cb-calendar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .cb-calendar-title {
    font-weight: 700;
    font-size: 14px;
    color: #0f172a;
  }
  .cb-calendar-nav-btn {
    background: none;
    border: none;
    font-size: 16px;
    font-weight: bold;
    color: #0284c7;
    cursor: pointer;
    padding: 2px 8px;
    border-radius: 4px;
    transition: background 0.2s;
  }
  .cb-calendar-nav-btn:hover {
    background: #f1f5f9;
  }
  .cb-calendar-weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    font-weight: 600;
    font-size: 11px;
    color: #64748b;
    margin-bottom: 4px;
  }
  .cb-calendar-weekday {
    padding: 4px 0;
  }
  .cb-calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
  }
  .cb-calendar-day {
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    border-radius: 8px;
    border: none;
    background: none;
    cursor: pointer;
    transition: all 0.2s;
  }
  .cb-calendar-day.empty {
    cursor: default;
    background: transparent;
  }
  .cb-calendar-day.enabled {
    color: #1e293b;
  }
  .cb-calendar-day.enabled:hover {
    background: #0284c7;
    color: white;
  }
  .cb-calendar-day.disabled {
    color: #cbd5e1;
    cursor: not-allowed;
    background: #f8fafc;
  }

  .cb-calendar-select {
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 600;
    color: #0f172a;
    background: white;
    outline: none;
    cursor: pointer;
  }
`;

function CalendarPicker({ onSelectDate, appointmentType, location, locationSchedules, isDOB }) {
  const [currentDate, setCurrentDate] = useState(new Date());

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDayIndex = new Date(year, month, 1).getDay();
  const totalDays = new Date(year, month + 1, 0).getDate();

  const prevMonth = () => {
    setCurrentDate(new Date(year, month - 1, 1));
  };

  const nextMonth = () => {
    setCurrentDate(new Date(year, month + 1, 1));
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let y = currentYear; y >= 1920; y--) {
    years.push(y);
  }

  const days = [];
  for (let i = 0; i < firstDayIndex; i++) {
    days.push(null);
  }
  for (let d = 1; d <= totalDays; d++) {
    days.push(d);
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div className="cb-calendar">
      <div className="cb-calendar-header">
        <button type="button" className="cb-calendar-nav-btn" onClick={prevMonth}>&lt;</button>
        <div style={{ display: "flex", gap: "6px" }}>
          <select
            value={month}
            onChange={(e) => setCurrentDate(new Date(year, parseInt(e.target.value), 1))}
            className="cb-calendar-select"
          >
            {monthNames.map((m, idx) => (
              <option key={m} value={idx}>{m}</option>
            ))}
          </select>
          <select
            value={year}
            onChange={(e) => setCurrentDate(new Date(parseInt(e.target.value), month, 1))}
            className="cb-calendar-select"
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>
        <button type="button" className="cb-calendar-nav-btn" onClick={nextMonth}>&gt;</button>
      </div>
      <div className="cb-calendar-weekdays">
        {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map(w => (
          <div key={w} className="cb-calendar-weekday">{w}</div>
        ))}
      </div>
      <div className="cb-calendar-grid">
        {days.map((day, idx) => {
          if (day === null) {
            return <div key={`empty-${idx}`} className="cb-calendar-day empty"></div>;
          }

          const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          const cellDate = new Date(year, month, day);
          cellDate.setHours(0, 0, 0, 0);

          let isDisabled = false;
          if (isDOB) {
            isDisabled = cellDate > today;
          } else {
            isDisabled = cellDate < today;

            if (!isDisabled && appointmentType === "offline" && location) {
              const schedulesForLoc = locationSchedules.filter(s => s.clinic_name === location);
              const isScheduled = schedulesForLoc.some(s => s.date === dateStr);
              if (!isScheduled) {
                isDisabled = true;
              }
            }
          }

          return (
            <button
              key={`day-${day}`}
              type="button"
              className={`cb-calendar-day ${isDisabled ? 'disabled' : 'enabled'}`}
              disabled={isDisabled}
              onClick={() => onSelectDate(dateStr)}
            >
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function ChatbotWidget() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(() => {
    return sessionStorage.getItem("cb_is_open") === "true";
  });

  const [messages, setMessages] = useState(() => {
    const saved = sessionStorage.getItem("cb_messages");
    return saved ? JSON.parse(saved) : [
      {
        id: 1,
        sender: "bot",
        text: "Welcome to Healthcare Appointment System.\n\nHow may I assist you today?",
        options: [
          { label: "1. Book Appointment", value: "Book Appointment" },
          { label: "2. Healthcare Assistance", value: "Healthcare Assistance" }
        ]
      }
    ];
  });

  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);

  const [bookingState, setBookingState] = useState(() => {
    return sessionStorage.getItem("cb_booking_state") || null;
  });

  const [bookingData, setBookingData] = useState(() => {
    const saved = sessionStorage.getItem("cb_booking_data");
    return saved ? JSON.parse(saved) : {
      doctorId: null,
      doctorName: "",
      reason: "",
      date: "",
      duration: 30,
      time: "",
      appointmentType: "online",
      location: "",
      additionalParticipants: [],
      patientDetails: null,
    };
  });

  const [availableSlots, setAvailableSlots] = useState(() => {
    const saved = sessionStorage.getItem("cb_available_slots");
    return saved ? JSON.parse(saved) : [];
  });

  const [locationSchedules, setLocationSchedules] = useState(() => {
    const saved = sessionStorage.getItem("cb_location_schedules");
    return saved ? JSON.parse(saved) : [];
  });

  const [otpSent, setOtpSent] = useState(() => {
    return sessionStorage.getItem("cb_otp_sent") === "true";
  });

  const [supportCategory, setSupportCategory] = useState("General Query");

  const messagesEndRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user") || "null");

  const formatReadableDate = (dateStr) => {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-").map(Number);
    const dateObj = new Date(y, m - 1, d);
    return dateObj.toLocaleDateString("en-US", { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const formatReadableTime = (timeStr) => {
    if (!timeStr) return "";
    const [h, m] = timeStr.split(":").map(Number);
    const ampm = h >= 12 ? 'PM' : 'AM';
    const displayH = h % 12 || 12;
    const displayM = String(m).padStart(2, '0');
    return `${displayH}:${displayM} ${ampm}`;
  };

  useEffect(() => {
    sessionStorage.setItem("cb_messages", JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    sessionStorage.setItem("cb_is_open", isOpen ? "true" : "false");
  }, [isOpen]);

  useEffect(() => {
    if (bookingState) {
      sessionStorage.setItem("cb_booking_state", bookingState);
    } else {
      sessionStorage.removeItem("cb_booking_state");
    }
  }, [bookingState]);

  useEffect(() => {
    sessionStorage.setItem("cb_booking_data", JSON.stringify(bookingData));
  }, [bookingData]);

  useEffect(() => {
    sessionStorage.setItem("cb_available_slots", JSON.stringify(availableSlots));
  }, [availableSlots]);

  useEffect(() => {
    sessionStorage.setItem("cb_location_schedules", JSON.stringify(locationSchedules));
  }, [locationSchedules]);

  useEffect(() => {
    sessionStorage.setItem("cb_otp_sent", otpSent ? "true" : "false");
  }, [otpSent]);

  useEffect(() => {
    const tag = document.createElement("style");
    tag.textContent = CHAT_STYLES;
    document.head.appendChild(tag);
  }, []);

  useEffect(() => {
    const loadDoctors = async () => {
      try {
        const res = await axios.get(`${API}/api/doctors/all`);
        setDoctorsList(res.data || []);
      } catch (err) {
        console.error("Failed to load doctors:", err);
      }
    };
    loadDoctors();
  }, []);

  useEffect(() => {
    const profileUpdated = sessionStorage.getItem("cb_profile_updated") === "true";
    const savedState = sessionStorage.getItem("cb_booking_state");

    if (profileUpdated && savedState === "profile_edit_redirect") {
      sessionStorage.removeItem("cb_profile_updated");
      if (!user || !user.id) return;
      setIsOpen(true);

      const resumeFlow = async () => {
        setLoading(true);
        try {
          const res = await axios.get(`${API}/api/users/profile/${user.id}`);
          const storedUser = JSON.parse(localStorage.getItem("user") || "null");
          if (storedUser) {
            localStorage.setItem("user", JSON.stringify({ ...storedUser, name: res.data.name, email: res.data.email }));
            window.dispatchEvent(new Event("storage"));
          }

          const dobFormatted = res.data.dob ? res.data.dob.split("T")[0] : "Not Specified";
          const detailsSummary = `Profile Updated Successfully.\n\nWelcome back.\n\nPlease review your updated details.\n\n` +
            `Name : ${res.data.name || "Not Specified"}\n` +
            `Email : ${res.data.email || "Not Specified"}\n` +
            `Phone Number : ${res.data.phone || "Not Specified"}\n` +
            `Gender : ${res.data.gender || "Not Specified"}\n` +
            `Blood Group : ${res.data.blood_group || "Not Specified"}\n` +
            `Date of Birth : ${dobFormatted}\n` +
            `Address : ${res.data.address || "Not Specified"}\n\n` +
            `Are these details correct?`;

          setBookingState("confirm_my_details");
          setBookingData(prev => ({
            ...prev,
            patientDetails: {
              name: res.data.name,
              email: res.data.email,
              phone: res.data.phone,
              gender: res.data.gender,
              blood_group: res.data.blood_group,
              dob: dobFormatted,
              address: res.data.address
            }
          }));

          addBotMessage(detailsSummary, [
            { label: "1. Yes, Continue", value: "yes_continue" },
            { label: "2. Edit My Details", value: "edit_my_details" }
          ]);
        } catch (err) {
          console.error(err);
          addBotMessage("Welcome back. Failed to load updated profile. Would you like to try again?", [
            { label: "1. Yes, Continue", value: "yes_continue" },
            { label: "2. Edit My Details", value: "edit_my_details" }
          ]);
          setBookingState("confirm_my_details");
        } finally {
          setLoading(false);
        }
      };
      resumeFlow();
    }
  }, [location.pathname]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  const addBotMessage = (text, options = null, type = null) => {
    setMessages(prev => [
      ...prev,
      { id: Date.now() + Math.random(), sender: "bot", text, options, type }
    ]);
  };

  const sanitizeVal = (val, fallback = "Information Unavailable") => {
    if (val === null || val === undefined) return fallback;
    const str = String(val).trim();
    if (!str || str.toLowerCase() === "null" || str.toLowerCase() === "undefined" || str.toLowerCase() === "not specified") {
      return fallback;
    }
    return str;
  };

  const showMainMenu = () => {
    addBotMessage(
      "Welcome to Healthcare Appointment System!\n\nHow can I assist you today?",
      [
        { label: "1. Book Appointment", value: "Book Appointment" },
        { label: "2. Healthcare Assistance", value: "Healthcare Assistance" },
        { label: "3. My Appointments", value: "My Appointments" },
        { label: "4. Exit", value: "Exit" }
      ]
    );
  };

  const showAssistanceMenu = () => {
    addBotMessage(
      "🩺 Healthcare Assistance\n\nPlease select one of the services below for assistance:",
      [
        { label: "1. Doctor Information", value: "Doctor Information" },
        { label: "2. Doctor Availability", value: "Doctor Availability" },
        { label: "3. Consultation Fees", value: "Consultation Fees" },
        { label: "4. My Appointments", value: "My Appointments" },
        { label: "5. Appointment Status", value: "Appointment Status" },
        { label: "6. Medical Reports", value: "Medical Reports" },
        { label: "7. My Documents", value: "My Documents" },
        { label: "8. Help & FAQs", value: "Help & FAQs" },
        { label: "9. Hospital Contact Details", value: "Hospital Contact Details" },
        { label: "10. Emergency Numbers", value: "Emergency Numbers" },
        { label: "11. Feedback", value: "Feedback" },
        { label: "12. Back", value: "Back" }
      ]
    );
  };

  const postActionOptions = [
    { label: "1. Go to Main Menu", value: "Main Menu" },
    { label: "2. View My Appointments", value: "My Appointments" },
    { label: "3. Book Another Appointment", value: "Book Appointment" },
    { label: "4. Ask a Healthcare Query", value: "Healthcare Assistance" },
    { label: "5. Exit", value: "Exit" }
  ];

  const addNextActionPrompt = (baseMsg) => {
    const fullMsg = baseMsg + "\n\nWhat would you like to do next?";
    addBotMessage(fullMsg, postActionOptions);
  };

  const handleDoctorInfo = () => {
    const activeDocs = doctorsList.filter(d => d.is_active === 1);
    if (activeDocs.length === 0) {
      addNextActionPrompt("There are no active doctors registered in our directory at the moment.");
      return;
    }
    let msg = "🩺 Doctor Information\n\n";
    activeDocs.forEach((d, idx) => {
      const expClean = sanitizeVal(d.experience, null);
      const expText = (expClean && expClean !== "0" && expClean !== "0 years")
        ? (expClean.includes("year") ? expClean : `${expClean} years`)
        : "Information Unavailable";

      msg += `${idx + 1}. Dr. ${d.name}\n` +
        `Specialization: ${sanitizeVal(d.specialization)}\n` +
        `Experience: ${expText}\n` +
        `Clinic/Hospital: ${sanitizeVal(d.clinic_name, "Information Unavailable")}\n` +
        `Location: ${sanitizeVal(d.city, "Information Unavailable")}\n`;

      if (d.qualification && sanitizeVal(d.qualification, null)) {
        msg += `Qualification: ${sanitizeVal(d.qualification)}\n`;
      }
      if (d.languages && sanitizeVal(d.languages, null)) {
        msg += `Languages: ${sanitizeVal(d.languages)}\n`;
      }
      msg += `\n`;
    });
    addNextActionPrompt(msg);
  };

  const handleDoctorAvailability = () => {
    const activeDocs = doctorsList.filter(d => d.is_active === 1);
    if (activeDocs.length === 0) {
      addNextActionPrompt("No doctor availability data found.");
      return;
    }
    let msg = "🕒 Doctor Availability\n\n";
    activeDocs.forEach((d) => {
      const formatAMPM = (timeStr) => {
        if (!timeStr) return "";
        const [h, m] = timeStr.split(':');
        const hours = parseInt(h, 10);
        return `${hours % 12 || 12}:${m} ${hours >= 12 ? 'PM' : 'AM'}`;
      };

      const startFormatted = formatAMPM(d.availability_start);
      const endFormatted = formatAMPM(d.availability_end);
      const workingHours = (startFormatted && endFormatted)
        ? `${startFormatted} – ${endFormatted}`
        : "8:00 AM – 7:00 PM";

      msg += `Doctor Name:\nDr. ${d.name}\n\n` +
        `Specialization:\n${sanitizeVal(d.specialization)}\n\n` +
        `Working Days:\n${sanitizeVal(d.working_days, "Monday – Friday")}\n\n` +
        `Working Hours:\n${workingHours}\n\n` +
        `Status:\n${d.is_active ? "Available Today" : "On Leave"}\n\n---\n\n`;
    });
    addNextActionPrompt(msg);
  };

  const handleConsultationFees = () => {
    const activeDocs = doctorsList.filter(d => d.is_active === 1);
    if (activeDocs.length === 0) {
      addNextActionPrompt("No doctor fee data found.");
      return;
    }
    let msg = "💳 Consultation Details\n\n";
    activeDocs.forEach((d) => {
      const feeText = d.consultation_fee ? `${d.consultation_fee}` : "Information Unavailable";
      msg += `Doctor:\nDr. ${d.name}\n\n` +
        `Specialization:\n${sanitizeVal(d.specialization)}\n\n` +
        `Doctor Consultation Fee:\n₹${feeText}\n\n` +
        `Available Modes:\n✔ Online\n✔ Offline\n\n---\n\n`;
    });
    addNextActionPrompt(msg);
  };

  const handleMyAppointments = async () => {
    if (!user || !user.id) {
      addBotMessage("You need to be logged in to view your appointments. Please log in first.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/appointments/user/${user.id}`);
      const appts = Array.isArray(res.data) ? res.data : res.data.data || [];
      if (appts.length === 0) {
        addNextActionPrompt("📋 My Appointments\n\nYou currently don't have any scheduled appointments.");
        return;
      }
      let msg = "📋 Scheduled Appointments\n\n";
      appts.forEach((a) => {
        const formattedDate = new Date(a.date).toLocaleDateString(undefined, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
        const statusText = a.status === 'confirmed' ? 'Confirmed' : a.status === 'cancelled' ? 'Cancelled' : 'Pending';
        const modeText = a.appointment_type === 'online' ? 'Online (Google Meet)' : 'Offline (In-Person)';

        msg += `Appointment Details\n\n` +
          `Appointment ID:\n#${a.id}\n\n` +
          `Doctor:\nDr. ${a.doctor_name}\n\n` +
          `Department:\n${sanitizeVal(a.specialization, "General Healthcare")}\n\n` +
          `Date:\n${formattedDate}\n\n` +
          `Time:\n${a.time ? a.time.slice(0, 5) : "Scheduled"}\n\n` +
          `Mode:\n${modeText}\n\n` +
          `Status:\n${statusText}\n\n---\n\n`;
      });
      addNextActionPrompt(msg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to retrieve your appointments. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleAppointmentStatus = async () => {
    if (!user || !user.id) {
      addBotMessage("You need to be logged in to view your appointment statuses. Please log in first.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/appointments/user/${user.id}`);
      const appts = Array.isArray(res.data) ? res.data : res.data.data || [];
      if (appts.length === 0) {
        addNextActionPrompt("📌 Appointment Status\n\nYou currently don't have any scheduled appointments.");
        return;
      }
      let msg = "📌 Appointment Status\n\n";
      appts.forEach((a) => {
        const bookingDate = a.created_at ? new Date(a.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : "Recently";
        msg += `Appointment Status\n\n` +
          `Appointment ID:\n#${a.id}\n\n` +
          `Doctor:\nDr. ${a.doctor_name}\n\n` +
          `Current Status:\n${a.status ? a.status.toUpperCase() : "PENDING"}\n\n` +
          `Booked On:\n${bookingDate}\n\n` +
          `Estimated Waiting Time:\n${a.waiting_time || "N/A"}\n\n---\n\n`;
      });
      msg += "To get full details for a specific appointment, please type status [ID] (for example: status 24).";
      addNextActionPrompt(msg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to retrieve appointment statuses. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSpecificStatus = async (id) => {
    if (!user || !user.id) {
      addBotMessage("You need to be logged in to check appointment details. Please log in first.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/appointments/user/${user.id}`);
      const appts = Array.isArray(res.data) ? res.data : res.data.data || [];
      const appointment = appts.find(a => String(a.id) === String(id));
      if (!appointment) {
        addBotMessage(`Could not find an appointment with ID #${id} linked to your account.`);
        return;
      }
      const formattedDate = new Date(appointment.date).toLocaleDateString(undefined, { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
      const bookingDate = appointment.created_at ? new Date(appointment.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : "Recently";
      let msg = `📌 Appointment Status\n\n` +
        `Appointment ID:\n#${appointment.id}\n\n` +
        `Doctor:\nDr. ${appointment.doctor_name}\n\n` +
        `Current Status:\n${appointment.status.toUpperCase()}\n\n` +
        `Booked On:\n${bookingDate}\n\n` +
        `Date & Time:\n${formattedDate} at ${appointment.time.slice(0, 5)}\n\n` +
        `Estimated Waiting Time:\n${appointment.waiting_time || "N/A"}\n`;
      if (appointment.appointment_type === 'online' && appointment.meeting_link) {
        msg += `\nGoogle Meet Link:\n${appointment.meeting_link}\n`;
      }
      addNextActionPrompt(msg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to retrieve appointment details. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleMedicalReports = async () => {
    if (!user || !user.id) {
      addBotMessage("You need to be logged in to view your medical reports. Please log in first.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/users/${user.id}/records`);
      const records = res.data || [];
      if (records.length === 0) {
        addNextActionPrompt("📑 Medical Reports\n\nYou don't have any medical reports yet.\n\nReports will automatically appear here after your consultation.");
        return;
      }
      let msg = "📑 Medical Reports & Clinical History\n\n";
      records.forEach((r, idx) => {
        const recordDate = new Date(r.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
        msg += `Report #${idx + 1} — ${recordDate}\n` +
          `- Doctor: Dr. ${r.doctor_name || 'Self Update'}\n` +
          `- Status: Complete\n`;
        if (r.recorded_height || r.recorded_weight || r.recorded_blood_group || r.recorded_blood_pressure) {
          msg += `- Vitals: ` +
            [
              r.recorded_height && `Height: ${r.recorded_height} cm`,
              r.recorded_weight && `Weight: ${r.recorded_weight} kg`,
              r.recorded_blood_group && `Blood Group: ${r.recorded_blood_group}`,
              r.recorded_blood_pressure && `BP: ${r.recorded_blood_pressure}`
            ].filter(Boolean).join(" | ") + `\n`;
        }
        msg += `- Clinical Notes: "${sanitizeVal(r.notes)}"\n\n`;
      });
      addNextActionPrompt(msg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to retrieve medical reports. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleHelpFAQs = () => {
    setBookingState("awaiting_help_category");
    addBotMessage(
      "❓ Help & Support\n\nChoose a category:",
      [
        { label: "1. Login Issue", value: "Login Issue" },
        { label: "2. Appointment Issue", value: "Appointment Issue" },
        { label: "3. Payment Issue", value: "Payment Issue" },
        { label: "4. Medical Reports", value: "Medical Reports" },
        { label: "5. Other", value: "Other" }
      ]
    );
  };

  const handleHelpFAQsCategory = (categoryName) => {
    setSupportCategory(categoryName);
    setBookingState("awaiting_help_feedback");
    addBotMessage(`You selected ${categoryName}.\n\nPlease type your query or issue details below:`);
  };

  const submitSupportQuery = async (category, queryText) => {
    setLoading(true);
    try {
      const ticketId = `TK-${Math.floor(100000 + Math.random() * 900000)}`;
      await axios.post(`${API}/api/chatbot/feedback`, {
        userId: user?.id,
        feedback: `[Category: ${category}] ${queryText}`,
        ticketId
      });

      const confirmationMsg = `✅ Support Request Submitted\n\n` +
        `Reference ID:\n#${ticketId}\n\n` +
        `Category:\n${category}\n\n` +
        `Status:\nOpen\n\n` +
        `Expected Response:\nWithin 24 Hours\n\n` +
        `Thank you for contacting Healthcare Support.\nOur support team will contact you shortly.`;

      addNextActionPrompt(confirmationMsg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to submit your support query. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleMyDocuments = async () => {
    if (!user || !user.id) {
      addBotMessage("You need to be logged in to view your documents. Please log in first.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${API}/api/files/${user.id}`);
      const filesList = res.data.files || [];
      if (filesList.length === 0) {
        addNextActionPrompt(
          "📁 Document Vault\n\nNo uploaded documents found.\n\nSupported Documents:\n• Aadhaar Card\n• Insurance Card\n• Previous Medical Reports\n• Prescriptions"
        );
        return;
      }
      let msg = "📁 Document Vault\n\n";
      filesList.forEach((file, idx) => {
        const cleanName = file.name && file.name.includes('-') 
          ? file.name.substring(file.name.indexOf('-') + 1) 
          : (file.name || "Uploaded Document");

        let uploadDate = "Recently";
        if (file.created_at) {
          const d = new Date(file.created_at);
          if (!isNaN(d.getTime())) {
            uploadDate = d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
          }
        }

        const docType = sanitizeVal(file.document_type, "General Document");
        const downloadUrl = `${API}/api/download/${encodeURIComponent(file.name)}`;

        msg += `${idx + 1}. Document Details\n` +
          `Type: ${docType}\n` +
          `Document Name: ${cleanName}\n` +
          `Upload Date: ${uploadDate}\n` +
          `[View Document](${file.url}) | [Download Document](${downloadUrl})\n\n`;
      });
      addNextActionPrompt(msg);
    } catch (err) {
      console.error(err);
      addBotMessage("Failed to retrieve your documents. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleHospitalContact = () => {
    addNextActionPrompt(
      "🏥 Hospital Contact Details\n\n" +
      "Address: Healthcare Main Campus, Sector 4, City Care Hub\n" +
      "Phone: +91 1800-123-4567 / +91 98765-43210\n" +
      "Email: support@meletenova.com\n" +
      "Working Hours: 24/7 OPD & Emergency Services"
    );
  };

  const handleEmergencyNumbers = () => {
    addNextActionPrompt(
      "🚨 Emergency Helpline Numbers\n\n" +
      "• Medical Emergency / Ambulance: 108 / 102\n" +
      "• Hospital Emergency Desk: +91 1800-999-000\n" +
      "• Women Helpline: 1091\n" +
      "• National Emergency Helpline: 112"
    );
  };

  const handleExit = () => {
    setBookingState(null);
    addBotMessage(
      "Thank you for using the Healthcare Appointment System.\n\nWe wish you good health.\n\nHave a wonderful day!"
    );
  };

  const handleNewChat = () => {
    sessionStorage.removeItem("cb_messages");
    sessionStorage.removeItem("cb_booking_state");
    sessionStorage.removeItem("cb_booking_data");
    sessionStorage.removeItem("cb_available_slots");
    sessionStorage.removeItem("cb_location_schedules");
    sessionStorage.removeItem("cb_otp_sent");
    sessionStorage.removeItem("cb_prev_route");
    sessionStorage.removeItem("cb_profile_updated");

    setBookingState(null);
    setOtpSent(false);
    setBookingData({
      doctorId: null,
      doctorName: "",
      reason: "",
      date: "",
      duration: 30,
      time: "",
      appointmentType: "online",
      location: "",
      additionalParticipants: [],
      patientDetails: null,
    });
    setAvailableSlots([]);
    setLocationSchedules([]);

    setMessages([
      {
        id: Date.now(),
        sender: "bot",
        text: "Welcome to Healthcare Appointment System!\n\nHow can I assist you today?",
        options: [
          { label: "1. Book Appointment", value: "Book Appointment" },
          { label: "2. Healthcare Assistance", value: "Healthcare Assistance" },
          { label: "3. My Appointments", value: "My Appointments" },
          { label: "4. Exit", value: "Exit" }
        ]
      }
    ]);
  };

  const handleSend = async (textToSend) => {
    const text = (textToSend || inputValue).trim();
    if (!text) return;

    if (!textToSend) setInputValue("");

    setMessages(prev => [
      ...prev,
      { id: Date.now(), sender: "user", text }
    ]);

    if (bookingState === "awaiting_help_category") {
      setBookingState(null);
      if (text === "1" || /\blogin\b/i.test(text)) {
        handleHelpFAQsCategory("Login Issue");
      } else if (text === "2" || /\bappointment\b/i.test(text)) {
        handleHelpFAQsCategory("Appointment Issue");
      } else if (text === "3" || /\bpayment\b/i.test(text)) {
        handleHelpFAQsCategory("Payment Issue");
      } else if (text === "4" || /\breports?\b/i.test(text)) {
        handleHelpFAQsCategory("Medical Reports");
      } else if (text === "5" || /\bother\b/i.test(text)) {
        handleHelpFAQsCategory("Other");
      } else {
        await submitSupportQuery("General Support", text);
      }
      return;
    }

    if (bookingState === "awaiting_help_feedback") {
      setBookingState(null);
      await submitSupportQuery(supportCategory || "General Support", text);
      return;
    }

    if (text === "Main Menu" || text === "Go to Main Menu" || /\b(main\s+menu|go\s+to\s+main\s+menu)\b/i.test(text)) {
      showMainMenu();
      setBookingState(null);
      return;
    }

    if (text === "Book Appointment" || text === "Book Another Appointment" || /\b(book\s+another\s+appointment|book\s+appointment)\b/i.test(text)) {
      processBookingFlow(text);
      return;
    }

    if (text === "Healthcare Assistance" || text === "Ask a Healthcare Query" || /\b(healthcare\s+assistance|ask\s+a\s+healthcare\s+query|healthcare\s+query)\b/i.test(text)) {
      showAssistanceMenu();
      return;
    }

    if (text === "Exit" || /\b(exit|quit|bye|goodbye)\b/i.test(text) || (text === "5" && bookingState === null)) {
      handleExit();
      return;
    }

    if (/\b(restart|reset|clear)\b/i.test(text)) {
      handleNewChat();
      return;
    }

    if (/\b(back|home)\b/i.test(text) || text === "12" || text === "Back") {
      showMainMenu();
      setBookingState(null);
      return;
    }

    if (/\b(doctor\s+information|doctor\s+info|doctors|find\s+doctor)\b/i.test(text)) {
      handleDoctorInfo();
      return;
    }

    if (/\b(doctor\s+availability|availability|working\s+hours|timings)\b/i.test(text)) {
      handleDoctorAvailability();
      return;
    }

    if (/\b(consultation\s+fees|consultation\s+fee|fees|cost|price)\b/i.test(text)) {
      handleConsultationFees();
      return;
    }

    if (/\b(my\s+appointments|view\s+appointments|my\s+bookings|check\s+appointments)\b/i.test(text) || text === "My Appointments" || (text === "2" && bookingState === null)) {
      await handleMyAppointments();
      return;
    }

    if (/\b(appointment\s+status|track\s+appointment)\b/i.test(text)) {
      await handleAppointmentStatus();
      return;
    }

    const statusMatch = text.match(/\bstatus\s*#?(\d+)\b/i);
    if (statusMatch) {
      await handleSpecificStatus(statusMatch[1]);
      return;
    }

    if (/\b(medical\s+reports|medical\s+records|reports|records|lab\s+reports)\b/i.test(text)) {
      await handleMedicalReports();
      return;
    }

    if (/\b(my\s+documents|documents|vault|uploaded\s+documents)\b/i.test(text) || text === "My Documents") {
      await handleMyDocuments();
      return;
    }

    if (/\b(help\s*&\s*faqs|help|faqs|faq|support|issue|problem)\b/i.test(text) || text === "Help & FAQs") {
      handleHelpFAQs();
      return;
    }

    if (/\b(hospital\s+contact|contact\s+details|hospital\s+phone|address)\b/i.test(text) || text === "9") {
      handleHospitalContact();
      return;
    }

    if (/\b(emergency|ambulance|urgent|helpline)\b/i.test(text) || text === "10") {
      handleEmergencyNumbers();
      return;
    }

    if (/\b(feedback|review|suggestion)\b/i.test(text) || text === "11") {
      handleHelpFAQsCategory("Feedback");
      return;
    }

    if (/\b(login\s+issue|cannot\s+login|login\s+problem|sign\s+in\s+issue)\b/i.test(text)) {
      handleHelpFAQsCategory("Login Issue");
      return;
    }

    if (/\b(payment\s+issue|payment\s+problem|refund|billing)\b/i.test(text)) {
      handleHelpFAQsCategory("Payment Issue");
      return;
    }

    if (/\b(cancel\s+appointment|cancel\s+booking)\b/i.test(text)) {
      addNextActionPrompt("To cancel an appointment, please navigate to My Appointments or type 'my appointments' to view your active bookings and select your appointment.");
      return;
    }

    if (/\b(reschedule\s+appointment|change\s+date|change\s+time)\b/i.test(text)) {
      addNextActionPrompt("To reschedule an appointment, you can cancel your existing booking under My Appointments and select a new preferred slot.");
      return;
    }

    if (bookingState !== null || /\b(book|appointment|schedule|reserve|doctor|consultation|slot)\b/i.test(text)) {
      processBookingFlow(text);
    } else if (/\b(hi|hello|hey|greetings|good\s+morning|good\s+afternoon|good\s+evening)\b/i.test(text) || (text === "1" && bookingState === null)) {
      showMainMenu();
    } else {
      await queryRAG(text);
    }
  };

  const showConfirmationSummary = (data) => {
    const formattedDate = formatReadableDate(data.date);
    const formattedTime = formatReadableTime(data.time);

    const summary = `Booking Confirmation\n\n` +
      `Doctor : Dr. ${data.doctorName}\n\n` +
      `Appointment Date : ${formattedDate}\n\n` +
      `Appointment Time : ${formattedTime}\n\n` +
      `Consultation Duration : ${data.duration} Minutes\n\n` +
      `Appointment Type : ${data.appointmentType === "online" ? "Online (Google Meet)" : "Offline (In-Person)"}\n\n` +
      `Reason for Appointment :\n${data.reason}\n\n\n` +
      `Please review the details above.\n\n` +
      `Are they correct?`;

    addBotMessage(summary, [
      { label: "1. Confirm Booking", value: "confirm" },
      { label: "2. Cancel Booking", value: "cancel" }
    ]);
  };

  const processBookingFlow = async (text) => {
    let data = { ...bookingData };

    if (bookingState === null) {
      setBookingState("book_for_whom");
      setBookingData({
        doctorId: null,
        doctorName: "",
        reason: "",
        date: "",
        duration: 30,
        time: "",
        appointmentType: "online",
        location: "",
        additionalParticipants: [],
        patientDetails: null,
      });
      setOtpSent(false);

      addBotMessage("Who would you like to book the appointment for?", [
        { label: "1. Appointment for Me", value: "me" },
        { label: "2. Appointment for Someone Else", value: "someone_else" }
      ]);
      return;
    }

    switch (bookingState) {
      case "book_for_whom": {
        const textLower = text.toLowerCase();
        if (textLower === "me" || textLower === "1" || /\bme\b/.test(textLower)) {
          if (!user || !user.id) {
            addBotMessage("You need to be logged in to book an appointment. Please log in first.");
            setBookingState(null);
            return;
          }

          setLoading(true);
          try {
            const res = await axios.get(`${API}/api/users/profile/${user.id}`);
            const dobFormatted = res.data.dob ? res.data.dob.split("T")[0] : "Not Specified";
            const detailsSummary = `Please review your details before proceeding.\n\n` +
              `Name : ${res.data.name || "Not Specified"}\n` +
              `Email : ${res.data.email || "Not Specified"}\n` +
              `Phone Number : ${res.data.phone || "Not Specified"}\n` +
              `Gender : ${res.data.gender || "Not Specified"}\n` +
              `Blood Group : ${res.data.blood_group || "Not Specified"}\n` +
              `Date of Birth : ${dobFormatted}\n` +
              `Address : ${res.data.address || "Not Specified"}\n\n` +
              `Are these details correct?`;

            setBookingState("confirm_my_details");
            data.patientDetails = {
              name: res.data.name,
              email: res.data.email,
              phone: res.data.phone,
              gender: res.data.gender,
              blood_group: res.data.blood_group,
              dob: dobFormatted,
              address: res.data.address
            };
            setBookingData(data);

            addBotMessage(detailsSummary, [
              { label: "1. Yes, Continue", value: "yes_continue" },
              { label: "2. Edit My Details", value: "edit_my_details" }
            ]);
          } catch (err) {
            console.error(err);
            addBotMessage("Failed to load your profile details. Please try again or type 'cancel' to reset.");
            setBookingState(null);
          } finally {
            setLoading(false);
          }
        } else if (textLower === "someone_else" || textLower === "2" || /\b(someone|else|other)\b/.test(textLower)) {
          setBookingState("someone_name");
          addBotMessage("Please provide the patient's details.\n\nName:");
        } else {
          addBotMessage("Who would you like to book the appointment for?", [
            { label: "1. Appointment for Me", value: "me" },
            { label: "2. Appointment for Someone Else", value: "someone_else" }
          ]);
        }
        break;
      }

      case "confirm_my_details": {
        const textLower = text.toLowerCase();
        if (textLower === "yes_continue" || textLower === "1" || /\byes|continue\b/.test(textLower)) {
          setBookingState("health_issue");
          addBotMessage("Please tell us about the health issue you are facing.");
        } else if (textLower === "edit_my_details" || textLower === "2" || /\bedit\b/.test(textLower)) {
          sessionStorage.setItem("cb_prev_route", window.location.pathname);
          setBookingState("profile_edit_redirect");
          addBotMessage("Redirecting you to your profile page to update your details...");
          setTimeout(() => {
            navigate("/profile");
          }, 800);
        } else {
          addBotMessage("Are these details correct?", [
            { label: "1. Yes, Continue", value: "yes_continue" },
            { label: "2. Edit My Details", value: "edit_my_details" }
          ]);
        }
        break;
      }

      case "someone_name": {
        if (text.length < 2) {
          addBotMessage("Please enter a valid name:");
          return;
        }
        data.patientDetails = { ...data.patientDetails, name: text };
        setBookingData(data);
        setBookingState("someone_phone");
        addBotMessage("Please provide the patient's Phone Number:");
        break;
      }

      case "someone_phone": {
        if (!/^\+?[\d\s-]{6,15}$/.test(text.trim())) {
          addBotMessage("Please enter a valid phone number:");
          return;
        }
        data.patientDetails = { ...data.patientDetails, phone: text };
        setBookingData(data);
        setBookingState("someone_gender");
        addBotMessage("Please provide the patient's Gender:", [
          { label: "Male", value: "Male" },
          { label: "Female", value: "Female" },
          { label: "Other", value: "Other" }
        ]);
        break;
      }

      case "someone_gender": {
        const gen = text.trim();
        if (!["Male", "Female", "Other"].some(g => new RegExp(g, "i").test(gen))) {
          addBotMessage("Please choose or enter a valid gender:", [
            { label: "Male", value: "Male" },
            { label: "Female", value: "Female" },
            { label: "Other", value: "Other" }
          ]);
          return;
        }
        data.patientDetails = { ...data.patientDetails, gender: gen };
        setBookingData(data);
        setBookingState("someone_dob");
        addBotMessage("Please select the patient's Date of Birth:", null, "calendar");
        break;
      }

      case "someone_dob": {
        let selectedDate = "";
        const match = text.match(/\b\d{4}-\d{2}-\d{2}\b/);
        if (match) {
          selectedDate = match[0];
        }

        if (!selectedDate) {
          addBotMessage("Please select a valid date from the calendar:");
          return;
        }
        data.patientDetails = { ...data.patientDetails, dob: selectedDate };
        setBookingData(data);
        setBookingState("someone_email");
        addBotMessage("Please provide the patient's Email Address:");
        break;
      }

      case "someone_email": {
        const email = text.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          addBotMessage("Please enter a valid email address:");
          return;
        }
        data.patientDetails = { ...data.patientDetails, email };
        setBookingData(data);
        setBookingState("someone_address");
        addBotMessage("Please provide the patient's Address:");
        break;
      }

      case "someone_address": {
        if (text.length < 3) {
          addBotMessage("Please enter a valid address:");
          return;
        }
        data.patientDetails = { ...data.patientDetails, address: text };
        setBookingData(data);
        setBookingState("someone_confirm");

        const detailsSummary = `Please review the details provided.\n\n` +
          `Name : ${data.patientDetails.name}\n` +
          `Phone Number : ${data.patientDetails.phone}\n` +
          `Gender : ${data.patientDetails.gender}\n` +
          `Date of Birth : ${data.patientDetails.dob}\n` +
          `Email : ${data.patientDetails.email}\n` +
          `Address : ${data.patientDetails.address}\n\n` +
          `Are these details correct?`;

        addBotMessage(detailsSummary, [
          { label: "1. Yes, Continue", value: "yes" },
          { label: "2. Edit Details", value: "edit" }
        ]);
        break;
      }

      case "someone_confirm": {
        const textLower = text.toLowerCase();
        if (textLower === "yes" || textLower === "1" || /\byes|continue\b/.test(textLower)) {
          setBookingState("health_issue");
          addBotMessage("Please tell us about the health issue you are facing.");
        } else if (textLower === "edit" || textLower === "2" || /\bedit|no\b/.test(textLower)) {
          setBookingState("someone_name");
          addBotMessage("Please provide the patient's details.\n\nName:");
        } else {
          addBotMessage("Are these details correct?", [
            { label: "1. Yes, Continue", value: "yes" },
            { label: "2. Edit Details", value: "edit" }
          ]);
        }
        break;
      }

      case "health_issue": {
        if (text.length < 3) {
          addBotMessage("Please describe the health issue in a few words:");
          return;
        }
        data.reason = text;
        setBookingData(data);

        const textLower = text.toLowerCase();
        let matchedSpec = null;
        let specDisplayName = "";

        if (/\b(heart|chest\s*pain|cardio|cardiac|palpitation)\b/.test(textLower)) {
          matchedSpec = "Cardiology";
          specDisplayName = "Cardiologist";
        } else if (/\b(skin|allergy|rash|acne|itching|dermat)\b/.test(textLower)) {
          matchedSpec = "Dermatology";
          specDisplayName = "Dermatologist";
        } else if (/\b(therapy|mental|group|stress|depression)\b/.test(textLower)) {
          matchedSpec = "Group Therapy";
          specDisplayName = "Group Therapist";
        } else if (/\b(hormone|thyroid|diabetes|endocrin)\b/.test(textLower)) {
          matchedSpec = "Endocrinology";
          specDisplayName = "Endocrinologist";
        }

        const activeDocs = matchedSpec
          ? doctorsList.filter(d => d.is_active === 1 && d.specialization === matchedSpec)
          : [];

        if (activeDocs.length > 0) {
          setBookingState("doctor");
          addBotMessage(
            `Based on the health issue, we recommend consulting a ${specDisplayName}. Please select a doctor:`,
            activeDocs.map(d => ({ label: `Dr. ${d.name}`, value: d.name }))
          );
        } else {
          setBookingState("doctor");
          addBotMessage(
            `I couldn't match your health issue to a specific specialist. Please select from our available doctors:`,
            doctorsList.filter(d => d.is_active === 1).map(d => ({ label: `Dr. ${d.name} (${d.specialization})`, value: d.name }))
          );
        }
        break;
      }

      case "doctor": {
        const doc = doctorsList.find(d =>
          d.is_active === 1 &&
          (new RegExp(d.name.replace(".", "\\."), "i").test(text) || new RegExp(text, "i").test(d.name))
        );

        if (!doc) {
          addBotMessage("Sorry, I couldn't find an active doctor matching that name. Please select from the list:",
            doctorsList.filter(d => d.is_active === 1).map(d => ({ label: `Dr. ${d.name} (${d.specialization})`, value: d.name }))
          );
          return;
        }

        data.doctorId = doc.id;
        data.doctorName = doc.name;
        setBookingData(data);

        if (!user || !user.id) {
          addBotMessage("You need to be logged in to book an appointment. Please log in first.");
          setBookingState(null);
          return;
        }

        setLoading(true);
        try {
          await axios.post(`${API}/api/auth/send-otp-booking`, { email: user.email });
          setOtpSent(true);
          setBookingState("otp_verify");
          addBotMessage(`A security OTP has been sent to your email (${user.email}). Please enter the 6-digit OTP code to verify your identity:`);
        } catch (err) {
          addBotMessage(`Error: ${err.response?.data?.message || "Failed to send security OTP. Flow reset."}`);
          setBookingState(null);
        } finally {
          setLoading(false);
        }
        break;
      }

      case "otp_verify": {
        const otp = text.trim();
        if (!/^\d{6}$/.test(otp)) {
          addBotMessage("Please enter a valid 6-digit numeric OTP.");
          return;
        }

        setLoading(true);
        try {
          await axios.post(`${API}/api/auth/verify-otp-booking`, { email: user?.email, otp });
          addBotMessage("Email verified successfully.");

          setBookingState("type");
          addBotMessage("Would you like an Online (Google Meet) or Offline (In-Person) appointment?", [
            { label: "Online (Google Meet)", value: "online" },
            { label: "Offline (In-Person)", value: "offline" }
          ]);
        } catch (err) {
          addBotMessage("Invalid or expired OTP. Please try entering the code again:");
        } finally {
          setLoading(false);
        }
        break;
      }

      case "type": {
        let selectedType = "";
        if (/\b(online|virtual|video|google|meet|call)\b/i.test(text)) {
          selectedType = "online";
        } else if (/\b(offline|in-person|clinic|visit|physical)\b/i.test(text)) {
          selectedType = "offline";
        }

        if (!selectedType) {
          addBotMessage("Please select or type: 'online' or 'offline':", [
            { label: "Online (Google Meet)", value: "online" },
            { label: "Offline (In-Person)", value: "offline" }
          ]);
          return;
        }

        data.appointmentType = selectedType;
        setBookingData(data);

        if (selectedType === "offline") {
          setLoading(true);
          try {
            const schedulesRes = await axios.get(`${API}/api/doctors/${data.doctorId}/location-schedules`);
            const schedules = schedulesRes.data || [];
            setLocationSchedules(schedules);

            const doc = doctorsList.find(d => d.id === data.doctorId);
            let docClinics = [];
            if (doc.clinics) {
              try { docClinics = JSON.parse(doc.clinics); }
              catch { docClinics = typeof doc.clinics === 'string' ? doc.clinics.split(',').map(c => c.trim()) : []; }
              docClinics = docClinics.map(c => typeof c === 'object' ? c.name : c).filter(Boolean);
            }
            if (docClinics.length === 0 && doc.clinic_name) docClinics = [doc.clinic_name];

            const scheduleClinics = [...new Set(schedules.map(s => s.clinic_name))];
            const allClinics = [...new Set([...docClinics, ...scheduleClinics])];

            if (allClinics.length === 0) {
              setBookingState("doctor_unavailable");
              addBotMessage(
                `Dr. ${doc ? doc.name : "XYZ"} is currently unavailable for appointments.\n\nPlease select another doctor or try again later.`,
                [
                  { label: "1. Select Another Doctor", value: "Select Another Doctor" },
                  { label: "2. Start a New Chat", value: "Start a New Chat" }
                ]
              );
            } else {
              setBookingState("location");
              addBotMessage("Please select the clinic location for your visit:", allClinics.map(c => ({ label: c, value: c })));
            }
          } catch (err) {
            addBotMessage("Failed to retrieve clinic locations. Flow reset.");
            setBookingState(null);
          } finally {
            setLoading(false);
          }
        } else {
          // online
          const doc = doctorsList.find(d => d.id === data.doctorId);
          if (!doc || !doc.availability_start || !doc.availability_end) {
            setBookingState("doctor_unavailable");
            addBotMessage(
              `Dr. ${doc ? doc.name : "XYZ"} is currently unavailable for appointments.\n\nPlease select another doctor or try again later.`,
              [
                { label: "1. Select Another Doctor", value: "Select Another Doctor" },
                { label: "2. Start a New Chat", value: "Start a New Chat" }
              ]
            );
          } else {
            setBookingState("date");
            addBotMessage("Please select your preferred appointment date.", null, "calendar");
          }
        }
        break;
      }

      case "location": {
        if (text.length < 3) {
          addBotMessage("Please select a valid location from the options list.");
          return;
        }

        data.location = text;
        setBookingData(data);

        setLoading(true);
        try {
          const schedulesRes = await axios.get(`${API}/api/doctors/${data.doctorId}/location-schedules`);
          const schedules = schedulesRes.data || [];
          setLocationSchedules(schedules);

          const schedulesForLoc = schedules.filter(s => s.clinic_name === text);
          if (schedulesForLoc.length === 0) {
            setBookingState("doctor_unavailable");
            const doc = doctorsList.find(d => d.id === data.doctorId);
            addBotMessage(
              `Dr. ${doc ? doc.name : "XYZ"} is currently unavailable for appointments.\n\nPlease select another doctor or try again later.`,
              [
                { label: "1. Select Another Doctor", value: "Select Another Doctor" },
                { label: "2. Start a New Chat", value: "Start a New Chat" }
              ]
            );
          } else {
            setBookingState("date");
            addBotMessage("Please select your preferred appointment date.", null, "calendar");
          }
        } catch (err) {
          addBotMessage("Failed to retrieve clinic location schedules. Flow reset.");
          setBookingState(null);
        } finally {
          setLoading(false);
        }
        break;
      }

      case "date": {
        let selectedDate = "";

        const match = text.match(/\b\d{4}-\d{2}-\d{2}\b/);
        if (match) {
          selectedDate = match[0];
        }

        if (!selectedDate) {
          addBotMessage("Please select a valid date from the calendar:");
          return;
        }

        const parsedSelected = new Date(selectedDate);
        parsedSelected.setHours(23, 59, 59, 999);
        if (parsedSelected < new Date()) {
          addBotMessage("The date cannot be in the past. Please choose a future date:");
          return;
        }

        if (data.appointmentType === "offline" && data.location) {
          const schedulesForLoc = locationSchedules.filter(s => s.clinic_name === data.location);
          const isScheduled = schedulesForLoc.some(s => s.date === selectedDate);
          if (!isScheduled) {
            addBotMessage(`Dr. ${data.doctorName} is not scheduled to work at ${data.location} on ${selectedDate}. Please select a different date:`);
            return;
          }
        }

        data.date = selectedDate;
        setBookingData(data);
        setBookingState("duration");
        addBotMessage("What is the consultation duration?", [
          { label: "15 Minutes", value: "15" },
          { label: "30 Minutes", value: "30" },
          { label: "45 Minutes", value: "45" },
          { label: "60 Minutes", value: "60" }
        ]);
        break;
      }

      case "duration": {
        const dur = parseInt(text);
        if (![15, 30, 45, 60].includes(dur)) {
          addBotMessage("Please select one of the standard durations: 15, 30, 45, or 60 minutes.", [
            { label: "15 Minutes", value: "15" },
            { label: "30 Minutes", value: "30" },
            { label: "45 Minutes", value: "45" },
            { label: "60 Minutes", value: "60" }
          ]);
          return;
        }

        data.duration = dur;
        setBookingData(data);

        setLoading(true);
        try {
          const res = await axios.get(`${API}/api/appointments/doctor/${data.doctorId}?date=${data.date}`);
          const booked = Array.isArray(res.data)
            ? res.data.filter(a => a.status === "confirmed").map(a => {
              const [h, m] = a.time.split(":").map(Number);
              const start = h * 60 + m;
              return { start, end: start + (Number(a.duration) || 30) };
            })
            : [];

          const doc = doctorsList.find(d => d.id === data.doctorId);
          const [startH, startM] = doc.availability_start.split(":").map(Number);
          const [endH, endM] = doc.availability_end.split(":").map(Number);
          let startMinutes = startH * 60 + startM;
          const endMinutes = endH * 60 + endM;
          const slotMinutes = data.duration;
          const slots = [];
          const now = new Date();

          while (startMinutes + slotMinutes <= endMinutes) {
            const h = Math.floor(startMinutes / 60);
            const m = startMinutes % 60;
            const slotStart = `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

            const [year, month, day] = data.date.split("-").map(Number);
            const slotDateTime = new Date(year, month - 1, day, h, m);

            const isBlocked = booked.some(
              (b) => startMinutes < b.end && startMinutes + slotMinutes > b.start
            );

            const isToday =
              now.getFullYear() === year &&
              now.getMonth() === month - 1 &&
              now.getDate() === day;

            const isFutureTime = !isToday || slotDateTime > now;

            if (isFutureTime && !isBlocked) {
              const eh = Math.floor((startMinutes + slotMinutes) / 60);
              const em = (startMinutes + slotMinutes) % 60;

              slots.push({
                value: slotStart,
                label: `${slotStart} → ${String(eh).padStart(2, "0")}:${String(em).padStart(2, "0")}`
              });
            }

            startMinutes += slotMinutes;
          }

          setAvailableSlots(slots);

          if (slots.length === 0) {
            addBotMessage(`I am sorry, there are no available slots for Dr. ${data.doctorName} on ${data.date} with a duration of ${data.duration} minutes. Flow reset.`);
            setBookingState(null);
          } else {
            setBookingState("time");
            addBotMessage("Please select an available time slot:", slots.map(s => ({ label: s.label, value: s.value })));
          }
        } catch (err) {
          addBotMessage("Failed to check doctor availability. Flow reset.");
          setBookingState(null);
        } finally {
          setLoading(false);
        }
        break;
      }

      case "time": {
        const slot = availableSlots.find(s => s.value === text || s.label.includes(text));
        if (!slot) {
          addBotMessage("Please select from the available time slots listed:", availableSlots.map(s => ({ label: s.label, value: s.value })));
          return;
        }

        data.time = slot.value;
        setBookingData(data);
        setBookingState("invite_participants_ask");
        addBotMessage("Would you like to invite additional participants?", [
          { label: "1. Add Participant", value: "add" },
          { label: "2. Skip", value: "skip" }
        ]);
        break;
      }

      case "invite_participants_ask": {
        const textLower = text.toLowerCase();
        if (textLower === "skip" || textLower === "2" || /\bskip\b/.test(textLower)) {
          setBookingState("confirm");
          showConfirmationSummary(data);
        } else if (textLower === "add" || textLower === "1" || /\b(add|participant)\b/.test(textLower)) {
          setBookingState("invite_participants_input");
          addBotMessage("Please enter the participant's email address:");
        } else {
          addBotMessage("Would you like to invite additional participants?", [
            { label: "1. Add Participant", value: "add" },
            { label: "2. Skip", value: "skip" }
          ]);
        }
        break;
      }

      case "invite_participants_input": {
        const email = text.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          addBotMessage("Invalid email address. Please enter a valid participant email address:");
          return;
        }
        const updatedParticipants = [...(data.additionalParticipants || []), email];
        data.additionalParticipants = updatedParticipants;
        setBookingData(data);

        setBookingState("invite_participants_ask");
        addBotMessage(`Added participant: ${email}.\n\nWould you like to invite another participant?`, [
          { label: "1. Add Participant", value: "add" },
          { label: "2. Skip", value: "skip" }
        ]);
        break;
      }

      case "confirm": {
        const textLower = text.toLowerCase();
        if (textLower === "confirm" || textLower === "1" || /\b(confirm|yes|correct|proceed)\b/.test(textLower)) {
          setLoading(true);
          try {
            const finalReason = data.patientDetails
              ? `Patient: ${data.patientDetails.name} (${data.patientDetails.gender}, DOB: ${data.patientDetails.dob}, Phone: ${data.patientDetails.phone}, Email: ${data.patientDetails.email}, Address: ${data.patientDetails.address}). Reason: ${data.reason}`
              : data.reason;

            const bookingPayload = {
              doctor_id: data.doctorId,
              user_id: user?.id,
              date: data.date,
              time: data.time,
              duration: parseInt(data.duration),
              appointment_type: data.appointmentType,
              location: data.appointmentType === "offline" ? data.location : null,
              additional_participants: data.additionalParticipants,
              reason: finalReason,
              ...(data.patientDetails && {
                patient_email: data.patientDetails.email,
                patient_name: data.patientDetails.name
              })
            };

            const res = await axios.post(`${API}/api/appointments`, bookingPayload);
            const meetLink = res.data.appointment?.meeting_link;
            const meetId = meetLink ? meetLink.split("/").pop() : "Not Applicable";

            const formattedDate = formatReadableDate(data.date);
            const formattedTime = formatReadableTime(data.time);

            let successMessage = `🎉 Appointment Booked Successfully!\n\n` +
              `Appointment ID: #${res.data.appointment?.id || "N/A"}\n\n` +
              `Doctor: Dr. ${data.doctorName}\n` +
              `Appointment Date: ${formattedDate}\n` +
              `Appointment Time: ${formattedTime}\n\n`;

            if (meetLink) {
              successMessage += `Google Meet Link: ${meetLink}\n` +
                `Meeting ID: ${meetId}\n\n`;
            }

            successMessage += `A confirmation email has been sent to your registered email address.\n\n` +
              `What would you like to do next?`;

            addBotMessage(successMessage, postActionOptions);
            toast.success("Appointment Booked!");

            sessionStorage.removeItem("cb_booking_state");
            sessionStorage.removeItem("cb_booking_data");
            sessionStorage.removeItem("cb_otp_sent");
            sessionStorage.removeItem("cb_prev_route");
            sessionStorage.removeItem("cb_profile_updated");

            setBookingState(null);
            setBookingData({
              doctorId: null,
              doctorName: "",
              reason: "",
              date: "",
              duration: 30,
              time: "",
              appointmentType: "online",
              location: "",
              additionalParticipants: [],
              patientDetails: null,
            });
            setAvailableSlots([]);
            setLocationSchedules([]);

          } catch (err) {
            console.error("Booking error:", err);
            const isConflict = err.response?.status === 400 || (err.response?.data?.message && /booked|conflict|slot|taken/i.test(err.response.data.message));

            if (isConflict) {
              try {
                const slotsRes = await axios.get(
                  `${API}/api/appointments/available-slots?doctorId=${data.doctorId}&date=${data.date}&duration=${data.duration}`
                );
                const freshSlots = (slotsRes.data.availableSlots || []).map((s) => ({
                  label: s.timeStr ? `${formatReadableTime(s.timeStr.slice(0, 5))} – ${formatReadableTime(s.endTimeStr ? s.endTimeStr.slice(0, 5) : s.timeStr.slice(0, 5))}` : String(s),
                  value: s.timeStr || String(s)
                }));

                const remainingSlots = freshSlots.filter(s => s.value !== data.time);
                setAvailableSlots(remainingSlots);

                const slotOptions = remainingSlots.map((s, idx) => ({ label: `${idx + 1}. ${s.label}`, value: s.value }));
                slotOptions.push(
                  { label: `${remainingSlots.length + 1}. Choose Another Date`, value: "choose_another_date" },
                  { label: `${remainingSlots.length + 2}. Cancel Booking`, value: "cancel_booking" }
                );

                const slotTimeFormatted = formatReadableTime(data.time);
                const conflictMsg = `❌ Sorry! The selected appointment slot (${slotTimeFormatted}) has just been booked by another patient.\n\nPlease choose another available time slot.\n\nAvailable Time Slots`;

                setBookingState("slot_taken_select_slot");
                addBotMessage(conflictMsg, slotOptions);
              } catch (slotErr) {
                console.error(slotErr);
                addBotMessage(`❌ Sorry! The selected appointment slot (${formatReadableTime(data.time)}) has just been booked by another patient, and no other slots are available for this date.\n\nPlease choose another date:`, null, "calendar");
                setBookingState("date");
              }
            } else {
              addBotMessage(`Booking failed: ${err.response?.data?.message || "Internal server error. Flow reset."}`);
              setBookingState(null);
            }
          } finally {
            setLoading(false);
          }
        } else {
          sessionStorage.removeItem("cb_booking_state");
          sessionStorage.removeItem("cb_booking_data");
          setBookingState(null);
          addNextActionPrompt("Booking process cancelled.");
        }
        break;
      }

      case "slot_taken_select_slot": {
        const textLower = text.toLowerCase().trim();
        if (textLower === "choose_another_date" || textLower === "choose another date" || textLower === String(availableSlots.length + 1) || /\b(choose\s+another\s+date|another\s+date|change\s+date)\b/.test(textLower)) {
          setBookingState("date");
          addBotMessage("Please select your preferred appointment date:", null, "calendar");
          return;
        }
        if (textLower === "cancel_booking" || textLower === "cancel booking" || textLower === "cancel" || textLower === String(availableSlots.length + 2) || /\b(cancel\s+booking|cancel)\b/.test(textLower)) {
          sessionStorage.removeItem("cb_booking_state");
          sessionStorage.removeItem("cb_booking_data");
          setBookingState(null);
          addNextActionPrompt("Booking process cancelled.");
          return;
        }

        let chosenSlot = null;
        const numIndex = parseInt(textLower, 10);
        if (!isNaN(numIndex) && numIndex >= 1 && numIndex <= availableSlots.length) {
          chosenSlot = availableSlots[numIndex - 1];
        } else {
          chosenSlot = availableSlots.find(s => 
            s.value === text.trim() || 
            s.label.toLowerCase().includes(textLower) || 
            (s.value && textLower.includes(s.value.slice(0, 5)))
          );
        }

        if (!chosenSlot && !/^\d{2}:\d{2}/.test(text.trim())) {
          const slotOptions = availableSlots.map((s, idx) => ({ label: `${idx + 1}. ${s.label}`, value: s.value }));
          slotOptions.push(
            { label: `${availableSlots.length + 1}. Choose Another Date`, value: "choose_another_date" },
            { label: `${availableSlots.length + 2}. Cancel Booking`, value: "cancel_booking" }
          );
          addBotMessage("Please select one of the available time slots listed below:", slotOptions);
          return;
        }

        const newTime = chosenSlot ? chosenSlot.value : text.trim();
        data.time = newTime;
        setBookingData(data);

        addBotMessage("Great! The selected time slot is available.");

        setBookingState("confirm");
        showConfirmationSummary(data);
        break;
      }

      case "doctor_unavailable": {
        const textLower = text.toLowerCase();
        
        // Find if any doctors would be available for this specialization
        const reasonLower = (data.reason || "").toLowerCase();
        let matchedSpec = null;
        if (/\b(heart|chest\s*pain|cardio|cardiac|palpitation)\b/.test(reasonLower)) {
          matchedSpec = "Cardiology";
        } else if (/\b(skin|allergy|rash|acne|itching|dermat)\b/.test(reasonLower)) {
          matchedSpec = "Dermatology";
        } else if (/\b(therapy|mental|group|stress|depression)\b/.test(reasonLower)) {
          matchedSpec = "Group Therapy";
        } else if (/\b(hormone|thyroid|diabetes|endocrin)\b/.test(reasonLower)) {
          matchedSpec = "Endocrinology";
        }

        const activeDocs = matchedSpec
          ? doctorsList.filter(d => d.is_active === 1 && d.specialization === matchedSpec && d.id !== data.doctorId)
          : doctorsList.filter(d => d.is_active === 1 && d.id !== data.doctorId);

        const hasAvailableDocs = activeDocs.length > 0;

        if (hasAvailableDocs) {
          if (textLower === "select another doctor" || textLower === "1" || /\b(select|another|doctor)\b/.test(textLower)) {
            setBookingState("doctor");
            addBotMessage(
              "Please select from our available doctors:",
              activeDocs.map(d => ({ label: `Dr. ${d.name} (${d.specialization})`, value: d.name }))
            );
          } else if (textLower === "start a new chat" || textLower === "2" || /\b(start|new|chat)\b/.test(textLower)) {
            handleNewChat();
          } else {
            const doc = doctorsList.find(d => d.id === data.doctorId);
            addBotMessage(
              `Dr. ${doc ? doc.name : "XYZ"} is currently unavailable for appointments.\n\nPlease select another doctor or try again later.`,
              [
                { label: "1. Select Another Doctor", value: "Select Another Doctor" },
                { label: "2. Start a New Chat", value: "Start a New Chat" }
              ]
            );
          }
        } else {
          // No doctors are available
          if (textLower === "start a new chat" || textLower === "1" || /\b(start|new|chat)\b/.test(textLower)) {
            handleNewChat();
          } else {
            addBotMessage(
              "Currently no doctors are available. Please try again later.",
              [
                { label: "1. Start a New Chat", value: "Start a New Chat" }
              ]
            );
          }
        }
        break;
      }

      default:
        setBookingState(null);
        break;
    }
  };

  const queryRAG = async (message) => {
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/chatbot/query`, {
        message,
        userId: user?.id
      });
      addBotMessage(res.data.reply || "No response received.");
    } catch (err) {
      console.error(err);
      addBotMessage("I am sorry, I encountered an issue connecting to our virtual assistant. Please ask again.");
    } finally {
      setLoading(false);
    }
  };

  const renderMessageText = (text) => {
    if (!text) return "";
    const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      parts.push(
        <a
          key={match.index}
          href={match[2]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1976d2", textDecoration: "underline", fontWeight: "600" }}
        >
          {match[1]}
        </a>
      );
      lastIndex = linkRegex.lastIndex;
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    if (parts.length === 0) return text;
    return parts;
  };

  return (
    <div className="cb-widget">
      {!isOpen && (
        <div className="cb-bubble" onClick={() => setIsOpen(true)} aria-label="Open Healthcare Chatbot">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </div>
      )}

      {isOpen && (
        <div className="cb-panel">
          <div className="cb-header">
            <div className="cb-header-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "6px" }}>
                <path d="M12 2v20M2 12h20"/>
              </svg>
              Health Assistant
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button className="cb-new-chat-btn" onClick={handleNewChat} title="Start a New Chat">
                New Chat
              </button>
              <button className="cb-header-close" onClick={() => setIsOpen(false)} aria-label="Close panel" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>

          <div className="cb-messages">
            {messages.map((m) => (
              <div key={m.id} className={`cb-message ${m.sender === "bot" ? "cb-msg-bot" : "cb-msg-user"}`}>
                <div style={{ whiteSpace: "pre-line" }}>{renderMessageText(m.text)}</div>

                {m.type === "calendar" && (
                  <CalendarPicker
                    onSelectDate={(dateStr) => handleSend(dateStr)}
                    appointmentType={bookingData.appointmentType}
                    location={bookingData.location}
                    locationSchedules={locationSchedules}
                    isDOB={bookingState === "someone_dob"}
                  />
                )}

                {m.options && (
                  <div className="cb-options">
                    {m.options.map((opt) => (
                      <button
                        key={opt.value}
                        className="cb-option-btn"
                        onClick={() => handleSend(opt.value)}
                      >
                        {opt.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}

            {loading && (
              <div className="cb-typing">
                <span className="cb-dot" />
                <span className="cb-dot" />
                <span className="cb-dot" />
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <form
            className="cb-input-area"
            onSubmit={(e) => {
              e.preventDefault();
              handleSend();
            }}
          >
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder={
                bookingState === "otp_verify"
                  ? "Enter 6-digit OTP..."
                  : "Ask about appointments, doctors, reports..."
              }
              className="cb-input"
              disabled={loading}
            />
            <button type="submit" className="cb-send" disabled={loading} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: "rotate(45deg) translate(-2px, 2px)" }}>
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
